import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var LegalStudies = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.734 6.014c-.2-.401-.501-.602-.902-.602h-8.52C27.813 2.305 25.207 0 21.999 0c-3.207 0-5.813 2.305-6.314 5.412h-8.52c-.4 0-.801.2-.901.602L.75 19.544c-.1.2-.1.401-.1.602.1 3.608 3.007 6.414 6.615 6.414s6.515-2.906 6.615-6.414c0-.2 0-.401-.1-.602L8.768 7.417h12.228v30.97h-8.018c-.601 0-1.002.401-1.002 1.002 0 .602.5 1.003 1.002 1.003H32.02c.602 0 1.002-.501 1.002-1.003 0-.6-.5-1.002-1.002-1.002h-9.02V7.417h12.227l-5.01 12.127c-.101.2-.101.401-.101.602.1 3.608 3.007 6.414 6.615 6.414s6.515-2.906 6.615-6.414c0-.2 0-.401-.1-.501L37.734 6.014ZM7.164 24.556c-2.204 0-4.008-1.504-4.41-3.508h8.921a4.633 4.633 0 0 1-4.51 3.508Zm4.11-5.513H3.156l4.009-9.922 4.109 9.922Zm6.515-13.63a4.309 4.309 0 0 1 4.21-3.408c2.104 0 3.808 1.403 4.209 3.307h-8.42v.1ZM36.832 9.12l4.01 9.922h-8.12l4.11-9.922Zm0 15.435c-2.205 0-4.009-1.504-4.41-3.508h8.92c-.601 2.004-2.405 3.508-4.51 3.508ZM8.367 42.998c0-.602.502-1.003 1.003-1.003h25.458c.6 0 1.002.502 1.002 1.003 0 .5-.501 1.002-1.002 1.002H9.37c-.602 0-1.003-.4-1.003-1.002Z"
  }));
});
LegalStudies.displayName = 'LegalStudies';
LegalStudies.defaultProps = {
  'aria-label': 'LegalStudies'
};
export default LegalStudies;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/LegalStudies.js
// module id = 3655
// module chunks = 11